import { Observable } from 'rxjs';

/**
 * Get JSON from File object.
 *
 * @param files list files
 * @returns Observable<any> JSON
 */
// TODO:  Set up the correct type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function BydGetJsonFromFile(files: File[]): Observable<any> {
  const fileReader = new FileReader();
  return new Observable((subscriber) => {
    fileReader.onload = (event: ProgressEvent<FileReader>) => {
      subscriber.next(JSON.parse(<string>event?.target?.result));
      subscriber.complete();
    };
    fileReader.readAsText(files[0]);
  });
}
